import { loginGoogle } from "../../services/google"
import { authGooglePayload } from "../../interfaces/google"
import { toast } from "react-toastify"
import { io } from "socket.io-client"
import criptografarDado from "../criptografarDado"

const AuthGoogle = async ({ idOrganizacao, grupo, idProjeto, email, tokens, isAuth, navigate }: authGooglePayload) => {

    try {

        const idProjetoCript = criptografarDado(idProjeto.toString())

        const payload = {
            idOrganizacao,
            tokens,
            email
        }

        const resposta = await toast.promise(loginGoogle(payload), {
            pending: 'Validando Suas Credenciais, aguarde!',
            success: 'Autenticação Bem Sucedida'
        })

        if (resposta.status === 200) {
            
            isAuth()

            const organizacao = resposta.data.idOrganizacao
            const usuario = resposta.data.id


            const socket = io(`${process.env.REACT_APP_API_GESTTOR}?idOrganizacao=${organizacao}`)

            const mensagemDados = { usuario }

            socket.emit('notificacaoUsuario', organizacao, mensagemDados)


            return navigate(`/?idProjeto=${idProjetoCript}&grupo=${grupo}&usuarioGesttor=${resposta.data.id}&perfilGesttor=${resposta.data.perfil}&token=${resposta.data.token}&usuarioGesttorAvatar=${resposta.data.avatar}&organizacaoGesttorAvatar=${resposta.data.avatarOrganizacao}&organizacaoGesttor=${resposta.data.idOrganizacao}`)

        }

    } catch (error: any) {

        if (error.response.status === 401) {
            return toast.error('Credenciais não Validadas. Tente Novamente')
        }

        if (error.response.status === 408) {
            return toast.error('Licença Expirada. Fale com o nosso Atendimento')
        }

        if (error.response.status === 0) {
            return toast.error('Servidor Indisponível. Tente Novamente Mais Tarde')
        }

        if (error.response.status === 403) {
            return toast.error('Acesso Negado. Fale com o administrador da sua empresa para liberar o acesso')
        }

        if (error.response.status === 500) {
            return toast.error('Falha ao Processar a sua Solicitação')
        }

    }
}

export {
    AuthGoogle
}